import { useEffect } from 'react';

import { useUrlQueryParam } from '@/UrlQueryParam';

import { getValidLocale, usePreferredLocale } from './usePreferredLocale';

export function useQueryParamLocale(): void {
  const { locale, setLocale } = usePreferredLocale();
  const { queryParam, removeQueryParam } = useUrlQueryParam('locale');
  /**
   * `useEffect` is often dangerous and unnecessary. This usage needs review by #ux-programs team.
   * See https://getcolor.atlassian.net/browse/UXTASK-1406
   */
  // nosemgrep:semgrep-rules.ui-useEffect
  useEffect(() => {
    if (queryParam) {
      // Important! clear the query param so that the user can choose a different locale.
      removeQueryParam();
      const validLocale = getValidLocale(queryParam);
      if (validLocale && locale !== validLocale) {
        setLocale(validLocale);
      }
    }
  }, [locale, queryParam, removeQueryParam, setLocale]);
}
